import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Breadcrumbs,
  Link,
  Box,
  Button,
} from "@mui/material";
import Read from "../../utils/read/Read";
import CssBaseline from "@mui/material/CssBaseline";
import KeyIcon from '@mui/icons-material/Key';

const ReadSecrets = () => {
  const [contador] = useState(0);
  useEffect(() => {}, [contador]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Box sx={{ width: "100%" }} paddingTop={5} paddingBottom={5}>
        <Stack spacing={5}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Inicio
            </Link>
            <Typography color="text.primary">Secretos</Typography>
          </Breadcrumbs>
          <Button
            variant="contained"
            tabIndex={-1}
            startIcon={<KeyIcon />}
            href={`/secrets/create`}
            sx={{ width: { xs: "100%", md: "100%", lg: "35%" } }}
          >
            Registrar Secreto
          </Button>
          <Read
            config={{
              admin: true,
              title: "Secretos registrados",
              endpoint: "/secrets",
              id: "id",
              onDelete: "/secrets",
              onView: `/secrets/view`,
              onUpdate: `/secrets/update`,
              headers: [
                {
                  id: "secretName",
                  numeric: false,
                  disablePadding: true,
                  label: "Secreto",
                },
              ],
            }}
          />
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default ReadSecrets;
